module.exports = __webpack_public_path__ + "img/bgm_gray.0fae4b91.png";